import { Translation as I18nTranslation } from '@simplywallst/hooks/useTranslation';
import type * as WebTranslations from '@assets/locales/en/web.json';

/**
 * Displays text translated using the current locale language.
 * Used to interpolate react components into language output.
 *
 * @example
 *
 * // Given a key which has the following value;
 * // `You've used <1>{{views}}/{{limit}}</1>  spots of your {{plan}}
 * // Plan's company view limit`
 * // And rendering the component `NotificationTag` in the space
 * // matching the translation value `<1>` will cause the
 * // `NotificationTag` component to be interpolated into the output
 * // for any locale language.
 * ```
 * <Translation
 *   i18nKey="app.topbar.nav.account.viewLimit"
 *   values={{
 *     views: limits.views,
 *     limit: limits.limit,
 *     plan: startCase(userAccess.planType),
 *   }}
 * >
 *   You've used
 *   <NotificationTag alert data-cy-id="company-view-limit-count">
 *     {{views}}/{{limit}}
 *   </NotificationTag>
 *   spots of your {{plan}} Plan’s company view limit
 *   </span>
 * </Translation>
 * ```
 */
export const Translation =
  // Cast the translate function to enforce typing + autocomplete on the web translation keys.
  I18nTranslation<keyof typeof WebTranslations>;
